import { FloraTypography } from '@grupoboticario/flora-react'

import { ARIA_LABEL_DEFAULT, DEFAULT_TEXT_COLOR } from '@/pages/benefits/events/constants'
import useDragScroll from '@/pages/benefits/events/hooks/useDragScroll'
import useHoverScroll from '@/pages/benefits/events/hooks/useHoverScroll'
import useKeyboardInteraction from '@/pages/benefits/events/hooks/useKeyboardInteraction'
import { containerStyles } from '@/pages/benefits/events/styles'

import * as S from './ScrollableCell.styles'

const ScrollableCell = ({
  children,
  tooltip,
  textColor = DEFAULT_TEXT_COLOR,
  textSize = 'bodySmallStandard',
  textWeight
}) => {
  const { handleMouseDown } = useDragScroll()
  const { handleMouseEnter, handleMouseLeave } = useHoverScroll()
  const { handleKeyDown } = useKeyboardInteraction()

  const ariaLabel = tooltip || ARIA_LABEL_DEFAULT

  return (
    <button
      aria-label={ariaLabel}
      onKeyDown={handleKeyDown}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={containerStyles}
      title={tooltip}
      type="button"
    >
      <FloraTypography css={S.getTextCss(textColor)} fontSize={textSize} fontWeight={textWeight}>
        {children}
      </FloraTypography>
    </button>
  )
}

export default ScrollableCell
